if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.variantIdInput.disabled =
          this.submitButton.disabled || !this.variantIdInput.value;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.variantsContainer = this.querySelector(".variants-container");
        if (this.variantsContainer) {
          this.variantsContainer.addEventListener(
            "change",
            this.onVariantChange.bind(this),
          );
          const checkedInput = this.variantsContainer.querySelector(
            'input[type="radio"]:checked',
          );
          if (checkedInput) this.onVariantChange({ target: checkedInput });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        this.applyVitajuzPackBuilderFormData(formData);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      applyVitajuzPackBuilderFormData(formData) {
        const productInfo = this.closest("product-info");
        const builder = productInfo?.querySelector("[data-vj-pack-builder]");
        if (!builder || !formData.has("id")) return;

        const quantitySelector = builder.dataset.quantityInput;
        const quantityInput = quantitySelector ? document.querySelector(quantitySelector) : null;
        const builderQuantityNode = builder.querySelector("[data-vj-pack-quantity-value]");
        const quantity = Math.max(
          Number(quantityInput?.value || builderQuantityNode?.textContent || formData.get("quantity") || 1),
          1,
        );

        formData.set("quantity", String(quantity));

        builder.querySelectorAll("[data-vj-pack-property]").forEach((input) => {
          if (!input.name) return;

          if (input.disabled) {
            formData.delete(input.name);
            return;
          }

          formData.set(input.name, input.value);
        });
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }

      onVariantChange(event) {
        const target = event.target;
        if (target.name !== "id") return;
        if (target.disabled) return;

        this.variantIdInput.value = target.value;

        const labels = this.variantsContainer.querySelectorAll(
          "label.variant-option",
        );
        labels.forEach((label) => {
          const input = label.querySelector('input[type="radio"]');
          const isSelected = input === target;
          label.classList.toggle("selected", isSelected);
          label.setAttribute("aria-pressed", isSelected);
          label.setAttribute("aria-selected", isSelected);
        });

        // Publish a variant-id based selection change so product-info updates
        try {
          const productInfo = this.closest("product-info");
          const productUrl = productInfo?.dataset.url || window.location.pathname;
          publish(PUB_SUB_EVENTS.variantIdSelectionChange, {
            data: {
              event,
              target,
              variantId: target.value,
              productUrl,
            },
          });
        } catch (e) {
          console.warn("Failed to publish variantIdSelectionChange", e);
        }
      }
    },
  );
}
